import { render, staticRenderFns } from "./TicketViewHeader.vue?vue&type=template&id=0d99f92a&"
import script from "./TicketViewHeader.vue?vue&type=script&lang=js&"
export * from "./TicketViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports